import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';

import { UserSessionService } from './usersession.service';
// import { AuthenticationService } from './authentication.service';
// import { AlertService } from './alert.service';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from './authentication.service';
import { SharedDataService } from './shared-data-service.service';
// import { TranslateService } from '@ngx-translate/core';
// import swal from 'sweetalert2';
// import { UserService } from './user.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    private baseUrl = environment.apiBaseUrl;
    LoginDetials: any;

    constructor(
        private router: Router,
        private sessionService: UserSessionService,
        private loader: LoaderService,
        private toastr: ToastrService,
        private authService: AuthenticationService,
        private SharedDataService: SharedDataService
    ) // private authService: AuthenticationService,
    // private alertService: AlertService,
    { }

    token = null

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        var skipLoaderUrls = [
            '/api/OrderDetail/getNotificationCount',
        ];
        this.LoginDetials = this.SharedDataService.getValue('MicroSoftLogin')
        if (this.LoginDetials != null) {
            skipLoaderUrls.push('/api/oauth/token')
            skipLoaderUrls.push('api/Page/GetPagesByRoleId')

        }
        else {
            skipLoaderUrls = [
                '/api/OrderDetail/getNotificationCount',
            ];
        }
        const shouldSkipLoader = skipLoaderUrls.some(url => request.url.includes(url));

        if (!shouldSkipLoader) {
            this.loader.start();
        }
        const started = Date.now();

        // add authorization header with jwt token if available
        // const authToken = this.sessionService.authToken();
        // const isTokenEndPoint = request.url.match('/api/token');
        // if (isTokenEndPoint === null && this.sessionService.userId() && authToken) {
        //     request = request.clone({
        //         setHeaders: {
        //             Authorization: `Bearer ${authToken}`,
        //         }
        //     });
        // }
        this.token = localStorage.getItem('token')
        if (this.token) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${this.token}` }
            });
        }

        return next.handle(request).pipe(
            tap((event: any) => {
                if (event instanceof HttpResponse) {
                    const action = request.urlWithParams.replace(
                        this.baseUrl,
                        ''
                    );
                    const elapsed = Date.now() - started;
                }
            }),
            catchError((error: any) => {

                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        localStorage.clear();
                        this.authService.logOut();
                        this.router.navigate(['/auth/login']);
                    } else if (error.status === 403) {
                        this.forceLogout();
                    } else {
                        this.SharedDataService.getLoginPageErrMsg = null;
                        this.broadcastFriendlyErrorMessage(error);
                        return throwError(() => error);

                    }
                }
                throw new Error(error);
            }),
            finalize(() => {
                setTimeout(() => {
                    if (!shouldSkipLoader) {
                        this.loader.stop();
                    }
                }, 0);
            })
        ) as any;
    }

    broadcastFriendlyErrorMessage(rejection) {
        console.log('error LIne no 96', rejection);

        let msg = '';
        if (rejection.status === 0 && (rejection.statusText === '' || rejection.statusText === 'Unknown Error')) {
            this.toastr.error("Oops Something Went Wrong!");
        }
        else if (rejection.status == 429) {
            // this.alertService.error('You are allowed to send only one OTP every 3 minutes, so try after sometime.');
        } else if (rejection.status === 400) {
            console.log('----------- error --------- ', rejection.error);
            // this.toastr.error(rejection.error);

            if (rejection.error) {
                // jshint ignore:line
                msg = rejection.error.message
                    ? rejection.error.message
                    : rejection.error; // jshint ignore:line
                this.SharedDataService.getLoginPageErrMsg = rejection.error.error;

                console.log('----------- error --------- ', rejection.error.error);


                if (rejection.error.error_description) {
                    this.toastr.error(rejection.error.error_description);
                } else if (rejection.error.error) {
                    this.toastr.error(rejection.error.error);
                }
                else if (rejection.error.errorList) {
                    rejection.error.errorList.forEach((error: { errorMessage: string }) => {
                        this.toastr.error(error.errorMessage);
                    });
                }
                else if (rejection.Message) {
                    this.toastr.error(rejection.Message);
                }
                else if (rejection.error.message) {
                    this.toastr.error(rejection.error.message);
                }
                else if (rejection.error) {
                    this.toastr.error(rejection.error);
                }
                else {
                    this.toastr.error("Opps Something Wrong");
                }
            }
            else {
                this.toastr.error("Opps Something Wrong");
            }
        } else if (rejection.status === 404) {
            if (rejection.error && rejection.error.message) {
                this.toastr.error(rejection.error.message);
            } else if (rejection.error) {
                this.toastr.error(rejection.error);
            } else if (rejection.message) {
                this.toastr.error(rejection.message);
            }
        } else if (rejection.status === 500) {
            if (!Array.isArray(rejection.error) && typeof rejection.error === 'string')
                this.toastr.error(rejection.error);
            else if (rejection.error.message)
                this.toastr.error(rejection.error.message);

            else
                this.toastr.error("Opps Something Wrong");
        } else if (rejection.status === 303) {
            this.toastr.error(rejection.error);
        }
        else if (rejection.status === 409) {
            if (rejection.error && rejection.error.Message) {
                // this.alertService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                // this.alertService.error(message);
            }
        } else if (rejection.responseStatus === 401) {
            // this.authService.logOut();
            this.router.navigate(['/login']);
        } else if (rejection.responseStatus === 0) {
            // this.alertService.error('Error occured, while uploading file');
        } else if (rejection.responseStatus === 400) {
            if (rejection.response) {
                // jshint ignore:line
                msg = rejection.response; // jshint ignore:line
            }
            else if (rejection.error.message)
                this.toastr.error(rejection.error.message);
            // this.alertService.error(msg);
        }
    }

    forceLogout() {
        // swal.fire({
        //     title: 'Logout',
        //     text: 'Another user logged in to your account',
        //     icon: 'warning',
        //     showCancelButton: false,
        //     confirmButtonColor: '#3085d6',
        //     confirmButtonText: 'Ok',
        // }).then((result) => {
        //     if (result.value) {
        //         this.authService.logOut();
        //         this.router.navigate(['/auth/login']);
        //     }
        // })
    }
}
